import SizeUtility from '../../../js/Utilities/SizeUtility.js';

class CardScroller extends HTMLElement {
  scrollContainer = false;
  controlsContainer = false;
  scrollButtons = [];

  constructor() {
    super();

    this.setAttribute('data-ready', 'true');

    this.scrollContainer = this.querySelector('.card-scroller__track');
    this.controlsContainer = this.querySelector('.card-scroller__controls');
    this.scrollButtons = [...this.querySelectorAll('[data-card-scroll]')];

    this._updateButtons = this.updateButtons.bind(this);
    this._onButtonClick = this.onButtonClick.bind(this);
  }
  connectedCallback() {
    this.addEventListeners();

    this.updateButtons();
  }
  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.scrollContainer.addEventListener('scroll', this._updateButtons);
    window.addEventListener('resize', this._updateButtons);

    this.scrollButtons.forEach((button, index) => {
      button._onButtonClick = this._onButtonClick.bind(
        this,
        button.getAttribute('data-card-scroll') * 1,
      );
      button.addEventListener('click', button._onButtonClick);
    });
  }
  removeEventListeners() {
    this.scrollContainer.removeEventListener('scroll', this._updateButtons);
    window.removeEventListener('resize', this._updateButtons);

    this.scrollButtons.forEach(button => {
      button.removeEventListener('click', button._onButtonClick);
      button._onButtonClick = null;
    });
  }

  updateButtons() {
    let scrollPosition = this.scrollContainer.scrollLeft;
    let maxScrollPosition = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
    let disabledCount = 0;
    this.scrollButtons.forEach(button => {
      button.removeAttribute('disabled');
      let buttonDir = button.getAttribute('data-card-scroll') * 1;

      if (buttonDir < 0 && scrollPosition === 0) {
        button.setAttribute('disabled', '');
        disabledCount++;
      }
      if (buttonDir > 0 && scrollPosition >= maxScrollPosition) {
        button.setAttribute('disabled', '');
        disabledCount++;
      }
    });

    if (disabledCount === this.scrollButtons.length) {
      this.controlsContainer.setAttribute('hidden', 'true');
    } else {
      this.controlsContainer.removeAttribute('hidden');
    }
  }

  onButtonClick(direction = 1) {
    if (1 || SizeUtility.isScreenGtSm()) {
      let scrollAmount = this.scrollContainer.scrollWidth / this.scrollContainer.children.length;
      let scrollPosition = this.scrollContainer.scrollLeft;
      let scrollIndex = Math.round(scrollPosition / scrollAmount);
      scrollIndex += direction;

      let newScrollPosition = scrollIndex * scrollAmount;
      this.scrollContainer.scrollTo(newScrollPosition, 0);
    } else {
      // Find the element in view and scroll to the next/previous one
      let elements = this.scrollContainer.children;
      let elementIndex = 0;

      for (let i = 0; i < elements.length; i++) {
        let element = elements[i];
        let rect = element.getBoundingClientRect();
        if (rect.left >= 0 && rect.right <= window.innerWidth) {
          elementIndex = i;
          break;
        }
      }
      elementIndex += direction;
      if (elementIndex < 0) elementIndex = 0;
      if (elementIndex >= elements.length) elementIndex = elements.length - 1;
      let targetElement = elements[elementIndex];

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'center',
        });
      }
    }
  }
}

customElements.define('card-scroller', CardScroller);
